import { type RequestServiceOptions, utils } from '@atlaskit/util-service-support';

import { createAtlAttributionHeader } from '../../../../common/fetch/atl-attribution-header';

const IMAGE_SEARCH_URL = '/gateway/api/assist/api/rovo/v1/image-search';

const DEFAULT_IMAGE_SEARCH_LIMIT = 20;

/**
 * Note: This type is mirrored in `@atlassian/smart-knowledge-cards` (src/media/images.tsx).
 * If you change it here, update the sibling definition there as well.
 */
export interface ImageResult {
	altText: string;
	title: string;
	url: string;
	thumbnailUrl: string;
	pageId: string;
	similarity: string;
	rank: number;
}

export interface ImageSearchResponse {
	images: ImageResult[];
	query: string;
	totalResults: number;
}

type FetchImagesArgs = {
	searchQuery: string;
	cloudId: string;
	workspaceId: string;
	product: string;
	limit?: number;
};

export async function fetchImages({
	searchQuery,
	cloudId,
	workspaceId,
	product,
	limit = DEFAULT_IMAGE_SEARCH_LIMIT,
}: FetchImagesArgs): Promise<ImageSearchResponse> {
	const options: RequestServiceOptions = {
		requestInit: {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-Product': product,
				'X-Experience-Id': 'ai-mate',
				'X-Cloudid': cloudId,
				...createAtlAttributionHeader({
					atlWorkspaceId: workspaceId,
					tenantId: cloudId,
					product,
				}),
			},
			body: JSON.stringify({ searchQuery, limit }),
		},
	};

	return utils.requestService<ImageSearchResponse>({ url: IMAGE_SEARCH_URL }, options);
}
